<template>
	<section class="px-10 pt-8 pb-16">
		<div class="flex items-baseline justify-between mb-6">
			<h2 class="font-display font-bold text-[19px] tracking-tight"
				:class="isLight ? 'text-[#0f1f1c]' : 'text-white'">
				{{ $t('eventsGrid.title') }}
				<span class="text-xs font-normal ml-2" :class="isLight ? 'text-[#6b8f89]' : 'text-[#a8d5cc]/60'">
					{{ events.length }} {{ $t('eventsGrid.happeningNow') }}
				</span>
			</h2>
			<router-link to="/discover" class="text-sm font-medium transition-opacity duration-200 hover:opacity-70"
				:class="isLight ? 'text-[#1a9b8a]' : 'text-[#a8d5cc]'">
				{{ $t('eventsGrid.seeAll') }}
			</router-link>
		</div>

		<div class="grid gap-3.5" v-if="events.length > 0"
			style="grid-template-columns: repeat(auto-fill, minmax(185px, 1fr))">
			<EventCardComponent v-for="event in events" :key="event.id" :event="event" :isLight="isLight"
				@click="selectedEvent = event" />
		</div>
		<div v-if="!events" class="flex flex-col items-center justify-center py-16 px-6 text-center">

			<div class="mb-5 flex h-20 w-20 items-center justify-center rounded-full"
				:class="isLight ? 'bg-[#EAF8F5]' : 'bg-[#1f2f2d]'">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24"
					stroke="currentColor" stroke-width="1.8" :class="isLight ? 'text-[#1a9b8a]' : 'text-[#a8d5cc]'">
					<path stroke-linecap="round" stroke-linejoin="round"
						d="M8 2v3m8-3v3M3.75 9.75h16.5M5.25 5.75h13.5A1.5 1.5 0 0120.25 7.25v11.5a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V7.25a1.5 1.5 0 011.5-1.5z" />
				</svg>
			</div>

			<h3 class="mb-2 text-lg font-semibold" :class="isLight ? 'text-gray-900' : 'text-white'">
				{{ $t('eventsGrid.noEvents') }}
			</h3>

			<p class="mb-6 max-w-sm text-sm" :class="isLight ? 'text-gray-500' : 'text-gray-400'">
				{{ $t('eventsGrid.noEventsDescription') }}
			</p>

			<router-link to="/discover"
				class="inline-flex text-white items-center gap-2 rounded-full px-5 py-3 font-medium transition-all duration-200 hover:scale-105"
				:class="isLight
						? 'bg-[#1a9b8a] hover:bg-[#0d6b5e]'
						: 'bg-[#1a9b8a] hover:bg-[#0d6b5e]'
					">
				<i class="pi pi-compass"></i>
				{{ $t('eventsGrid.discoverEvents') }}
			</router-link>

		</div>
		<!-- Loading -->
		<div v-if="isLoading" class="flex flex-col items-center justify-center py-16 gap-3">
			<svg class="w-6 h-6 animate-spin text-primary-400" fill="none" viewBox="0 0 24 24">
				<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
				<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
			</svg>
			<p class="text-[13px] text-muted dark:text-muted-light" :class="isLight ? 'text-gray-900' : 'text-white'">Loading events…</p>
		</div>
		<MapEventModelComponent v-if="selectedEvent" :showModal="!!selectedEvent" :selectedEvent="selectedEvent"
			:isLight="isLight" @close="selectedEvent = null" />
	</section>
</template>

<script>
import EventCardComponent from "./EventCardComponent.vue";
import MapEventModelComponent from "./MapEventModelComponent.vue";

export default {
	name: "EventsGridComponent",
	components: { EventCardComponent, MapEventModelComponent },
	props: {
		events: { type: Array, default: () => [] },
		isLight: Boolean,
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return { selectedEvent: null };
	},
};
</script>